/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/

import { icon_border_all } from './editor/border_all.icon';
import { icon_attach_money } from './editor/attach_money.icon';
import { icon_attach_file } from './editor/attach_file.icon';
import { icon_border_bottom } from './editor/border_bottom.icon';
import { icon_border_clear } from './editor/border_clear.icon';
import { icon_border_color } from './editor/border_color.icon';
import { icon_border_horizontal } from './editor/border_horizontal.icon';
import { icon_border_inner } from './editor/border_inner.icon';
import { icon_border_outer } from './editor/border_outer.icon';
import { icon_border_left } from './editor/border_left.icon';
import { icon_border_style } from './editor/border_style.icon';
import { icon_border_right } from './editor/border_right.icon';
import { icon_border_top } from './editor/border_top.icon';
import { icon_border_vertical } from './editor/border_vertical.icon';
import { icon_bubble_chart } from './editor/bubble_chart.icon';
import { icon_drag_handle } from './editor/drag_handle.icon';
import { icon_format_align_center } from './editor/format_align_center.icon';
import { icon_format_align_justify } from './editor/format_align_justify.icon';
import { icon_format_align_right } from './editor/format_align_right.icon';
import { icon_format_align_left } from './editor/format_align_left.icon';
import { icon_format_bold } from './editor/format_bold.icon';
import { icon_format_clear } from './editor/format_clear.icon';
import { icon_format_color_reset } from './editor/format_color_reset.icon';
import { icon_format_color_fill } from './editor/format_color_fill.icon';
import { icon_format_color_text } from './editor/format_color_text.icon';
import { icon_format_italic } from './editor/format_italic.icon';
import { icon_format_line_spacing } from './editor/format_line_spacing.icon';
import { icon_format_indent_increase } from './editor/format_indent_increase.icon';
import { icon_format_indent_decrease } from './editor/format_indent_decrease.icon';
import { icon_format_list_numbered } from './editor/format_list_numbered.icon';
import { icon_format_size } from './editor/format_size.icon';
import { icon_format_paint } from './editor/format_paint.icon';
import { icon_format_list_bulleted } from './editor/format_list_bulleted.icon';
import { icon_format_quote } from './editor/format_quote.icon';
import { icon_format_shapes } from './editor/format_shapes.icon';
import { icon_format_strikethrough } from './editor/format_strikethrough.icon';
import { icon_format_textdirection_l_to_r } from './editor/format_textdirection_l_to_r.icon';
import { icon_functions } from './editor/functions.icon';
import { icon_format_textdirection_r_to_l } from './editor/format_textdirection_r_to_l.icon';
import { icon_format_underlined } from './editor/format_underlined.icon';
import { icon_highlight } from './editor/highlight.icon';
import { icon_insert_chart } from './editor/insert_chart.icon';
import { icon_insert_comment } from './editor/insert_comment.icon';
import { icon_insert_drive_file } from './editor/insert_drive_file.icon';
import { icon_insert_invitation } from './editor/insert_invitation.icon';
import { icon_insert_emoticon } from './editor/insert_emoticon.icon';
import { icon_insert_photo } from './editor/insert_photo.icon';
import { icon_insert_link } from './editor/insert_link.icon';
import { icon_linear_scale } from './editor/linear_scale.icon';
import { icon_merge_type } from './editor/merge_type.icon';
import { icon_mode_edit } from './editor/mode_edit.icon';
import { icon_mode_comment } from './editor/mode_comment.icon';
import { icon_monetization_on } from './editor/monetization_on.icon';
import { icon_money_off } from './editor/money_off.icon';
import { icon_pie_chart } from './editor/pie_chart.icon';
import { icon_multiline_chart } from './editor/multiline_chart.icon';
import { icon_publish } from './editor/publish.icon';
import { icon_pie_chart_outlined } from './editor/pie_chart_outlined.icon';
import { icon_show_chart } from './editor/show_chart.icon';
import { icon_short_text } from './editor/short_text.icon';
import { icon_space_bar } from './editor/space_bar.icon';
import { icon_text_fields } from './editor/text_fields.icon';
import { icon_vertical_align_bottom } from './editor/vertical_align_bottom.icon';
import { icon_strikethrough_s } from './editor/strikethrough_s.icon';
import { icon_title } from './editor/title.icon';
import { icon_vertical_align_center } from './editor/vertical_align_center.icon';
import { icon_vertical_align_top } from './editor/vertical_align_top.icon';
import { icon_wrap_text } from './editor/wrap_text.icon';
var icons = {
  "border_all" : icon_border_all,
"attach_money" : icon_attach_money,
"attach_file" : icon_attach_file,
"border_bottom" : icon_border_bottom,
"border_clear" : icon_border_clear,
"border_color" : icon_border_color,
"border_horizontal" : icon_border_horizontal,
"border_inner" : icon_border_inner,
"border_outer" : icon_border_outer,
"border_left" : icon_border_left,
"border_style" : icon_border_style,
"border_right" : icon_border_right,
"border_top" : icon_border_top,
"border_vertical" : icon_border_vertical,
"bubble_chart" : icon_bubble_chart,
"drag_handle" : icon_drag_handle,
"format_align_center" : icon_format_align_center,
"format_align_justify" : icon_format_align_justify,
"format_align_right" : icon_format_align_right,
"format_align_left" : icon_format_align_left,
"format_bold" : icon_format_bold,
"format_clear" : icon_format_clear,
"format_color_reset" : icon_format_color_reset,
"format_color_fill" : icon_format_color_fill,
"format_color_text" : icon_format_color_text,
"format_italic" : icon_format_italic,
"format_line_spacing" : icon_format_line_spacing,
"format_indent_increase" : icon_format_indent_increase,
"format_indent_decrease" : icon_format_indent_decrease,
"format_list_numbered" : icon_format_list_numbered,
"format_size" : icon_format_size,
"format_paint" : icon_format_paint,
"format_list_bulleted" : icon_format_list_bulleted,
"format_quote" : icon_format_quote,
"format_shapes" : icon_format_shapes,
"format_strikethrough" : icon_format_strikethrough,
"format_textdirection_l_to_r" : icon_format_textdirection_l_to_r,
"functions" : icon_functions,
"format_textdirection_r_to_l" : icon_format_textdirection_r_to_l,
"format_underlined" : icon_format_underlined,
"highlight" : icon_highlight,
"insert_chart" : icon_insert_chart,
"insert_comment" : icon_insert_comment,
"insert_drive_file" : icon_insert_drive_file,
"insert_invitation" : icon_insert_invitation,
"insert_emoticon" : icon_insert_emoticon,
"insert_photo" : icon_insert_photo,
"insert_link" : icon_insert_link,
"linear_scale" : icon_linear_scale,
"merge_type" : icon_merge_type,
"mode_edit" : icon_mode_edit,
"mode_comment" : icon_mode_comment,
"monetization_on" : icon_monetization_on,
"money_off" : icon_money_off,
"pie_chart" : icon_pie_chart,
"multiline_chart" : icon_multiline_chart,
"publish" : icon_publish,
"pie_chart_outlined" : icon_pie_chart_outlined,
"show_chart" : icon_show_chart,
"short_text" : icon_short_text,
"space_bar" : icon_space_bar,
"text_fields" : icon_text_fields,
"vertical_align_bottom" : icon_vertical_align_bottom,
"strikethrough_s" : icon_strikethrough_s,
"title" : icon_title,
"vertical_align_center" : icon_vertical_align_center,
"vertical_align_top" : icon_vertical_align_top,
"wrap_text" : icon_wrap_text,
};
export { icons };
